import React from 'react';
import { ClerkComponentsHero, ClerkComponentsFeature } from 'components';
import { TFeature } from 'types';

type TClerkComponentsTemplateProps = {
  text: {
    heroTitle: string;
    heroDesc: string;
  };
  image: {
    heroImage: string;
  };
  json: {
    features: [TFeature];
  };
};

export const ClerkComponentsTemplate: React.FC<
  TClerkComponentsTemplateProps
> = ({ image, text, json }) => {
  const featureImages = Object.entries(image).filter(([key]) =>
    key.includes('featureImage')
  );

  return (
    <>
      <ClerkComponentsHero
        heroTitle={text.heroTitle}
        heroDesc={text.heroDesc}
        heroImage={image.heroImage}
      />

      <div className="flex flex-col px-6 py-24 mx-auto max-w-7xl gap-y-12 lg:gap-y-24">
        {json.features?.map((feature, index) => (
          <ClerkComponentsFeature
            key={feature.featureTitle}
            {...feature}
            image={featureImages[index]?.[1]}
            imagePosition={index % 2 === 0 ? 'left' : 'right'}
          />
        ))}
      </div>
    </>
  );
};
